import {useTranslation} from 'react-i18next';
import {isGuidebookLanguageSupported} from '@chekin/core';

function useGuidebookLanguage() {
  const {i18n} = useTranslation();
  const language = i18n.language;

  return {language, isLanguageSupported: isGuidebookLanguageSupported(language)};
}

export {useGuidebookLanguage};
